import { format } from 'date-fns';

export const formatShortDate = (date) => {
  const parsedDate = new Date(date);
  if (Number.isNaN(parsedDate.getTime())) {
    return '';
  }
  return format(parsedDate, 'dd/MM/yyyy');
};

export const formatShortTime = (date) => {
  const parsedDate = new Date(date);
  if (Number.isNaN(parsedDate.getTime())) {
    return '';
  }
  return format(parsedDate, 'HH:mm:ss');
};

export const formatDate = (date) => {
  const parsedDate = new Date(date);
  if (Number.isNaN(parsedDate.getTime())) {
    return '';
  }
  return format(parsedDate, 'yyyy-MM-dd HH:mm:ss');
};
